
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/marqeta",
      function () {
        return require("private-next-pages/docs/auth/partnerships/marqeta.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/marqeta"])
      });
    }
  